import { VariaveisAmbiente } from 'config';
import { PessoaSocioModel } from 'model/api/gestao/pessoa/pessoa-socio-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function usePostAdicionarPessoaSocio() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postAdicionarPessoaSocio = useCallback(
        (pessoaId: string, socio: PessoaSocioModel) =>
            invocarApi({
                method: 'POST',
                url: `/${VariaveisAmbiente.apiVersion}/pessoa/${pessoaId}/socio`,
                data: socio,
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postAdicionarPessoaSocio,
    };
}
